import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      },
      {
        path: '/user/user_centered',
        name: 'user_centered',
        meta: {
          title: '用户中心',
          hideInMenu: true
        },
        component: () => import('@/components/main/components/user/user-centered.vue')
      },
    ]
  },
  {
    path: '/multilevel',  
    name: 'multilevel',
    meta: {
      icon: 'md-contacts',
      title: '系统管理'
    },
    component: Main,
    children: [
      {
        path: 'client_management',
        name: 'client_management',
        meta: {
          icon: 'ios-man',
          title: '租户管理'
        },
        component: () => import('@/view/multilevel/client_management.vue')
      },
      {
        path: 'role_management',
        name: 'role_management',
        meta: {
          icon: 'md-person',
          title: '角色管理'
        },
        component: () => import('@/view/multilevel/role_management.vue')
      },
      {
        path: 'user_management',
        name: 'user_management',
        meta: {
          icon: 'ios-contact',
          title: '用户管理'
        },
        component: () => import('@/view/multilevel/user_management.vue')
      },
      {
        path: '/user/user_password',
        name: 'user_password',
        meta: {
          title: '修改密码',
          hideInMenu: true
        },
        component: () => import('@/components/main/components/user/user_password.vue')
      },
      {
        path: 'JournalList',
        name: 'JournalList',
        meta: {
          icon: 'ios-calendar',
          title: '日志管理'
        },
        component: () => import('@/view/multilevel/JournalList.vue')
      },
      {
        path: 'formula_management',
        name: 'formula_management',
        meta: {
          icon: 'ios-albums-outline',
          title: '公式管理'
        },
        component: () => import('@/view/multilevel/formula_management.vue')
      },
      {
        path: '/multilevel/new_formula',
        name: 'new_formula',
        meta: {
          icon: 'ios-contact',
          hideInMenu:true,
          title: '公式新建'
        },
        component: () => import('@/view/multilevel/new_formula.vue')
      },
      {
        path: '/multilevel/formula_properties/:id',
        name: 'formula_properties',
        meta: {
          icon: 'ios-contact',
          hideInMenu:true,
          title: '公式属性'
        },
        component: () => import('@/view/multilevel/formula_properties.vue')
      },
      {
        path: '/multilevel/formula_instance/:id',
        name: 'formula_instance',
        meta: {
          icon: 'ios-contact',
          hideInMenu:true,
          title: '公式实例'
        },
        component: () => import('@/view/multilevel/formula_instance.vue')
      },
      {
        path: '/multilevel/formula_configuration/:id',
        name: 'formula_configuration',
        meta: {
          icon: 'ios-contact',
          hideInMenu:true,
          title: '配置公式'
        },
        component: () => import('@/view/multilevel/formula_configuration.vue')
      },
    ]
  },
  {
    path: '/engineering_management',
    name: 'engineering_management',
    meta: {
      icon: 'md-menu',
      showAlways: true,
      title: '工程管理'
    },
    component: Main,
    children:[
      {
        path: '/engineering_management/engineering_index',
        name: 'engineering_index',
        meta: {
          icon: 'ios-briefcase-outline',
          title: '工程检索'
        },
        component: () => import('@/view/engineering_management/engineering_index')
      },
      {
        path: '/engineering_management/new_engineering',
        name: 'new_engineering',
        meta: {
          icon: 'md-menu',
          title: '新建工程',
          hideInMenu: true,
        },
        component: () => import('@/view/engineering_management/new_engineering')
      },
      {
        path: '/engineering_management/engineering_attr/prj',
        name: 'engineering_attr',
        meta: {
          icon: 'md-menu',
          title: '工程属性',
          hideInMenu: true,
        },
        component: () => import('@/view/engineering_management/engineering_attr')
      },
      {
        path: '/engineering_management/maps/prj',
        name: 'maps',
        meta: {
          icon: 'md-menu',
          title: '地图标注',
          hideInMenu: true,
        },
        component: () => import('@/view/engineering_management/maps')
      },
      {
        path:'/engineering_management/directory_management',
        name: 'directory_management',//调整为directory_search
        meta: {
          icon: 'ios-browsers-outline',
          title: '断面检索', 
        },
        component: () => import('@/view/engineering_management/directory_management.vue')
      },
      {
        path:'/engineering_management/directory_attar',
        name: 'directory_attar',
        meta: {
          icon: 'md-menu',
          title: '断面属性',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering_management/directory_attar.vue')
      },
      {
        path:'/engineering_management/section',
        name: 'section',
        meta: {
          icon: 'md-menu',
          title: '子断面属性',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering_management/section.vue')
      },
      {
        path:'/engineering_management/point_search',
        name: 'point_search',  //调整为point_search
        meta: {
          icon: 'ios-disc',
          title: '测点检索',//后面的显示
        },
        component: () => import('@/view/engineering_management/point_search')
      },
      {
        path:'/engineering_management/point_attr',
        name: 'point_attr',
        meta: { 
          icon: 'md-menu',
          title: '测点属性',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering_management/point_attr')
      },
      {
        path:'/engineering_management/newMorePoint',
        name: 'new_more_point',
        meta: { 
          icon: 'md-menu',
          title: '导入测点',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering_management/NewMorePoint')
      },
      {
        path:'/engineering_management/newMorePoint',
        name: 'new_more_point',
        meta: { 
          icon: 'md-menu',
          title: '导入测点',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering_management/NewMorePoint')
      },
      
    ]
  },
  {
    path: '/data_browse',
    name: 'data_browse',
    meta: {
      icon: 'ios-paper',
      showAlways: true,
      title: '数据查询'
    },
    component: Main,
    children:[
      {
        path: '/data_browse/data_browse_point',
        name: 'data_browse_point',
        meta: {
          icon: 'md-radio-button-on',
          title: '测点数据'
        },
        component: () => import('@/view/statistics/project_point_list')
      },
      {
        path: '/data_browse/data_browse_statistics',
        name: 'data_browse_statistics',
        meta: {
          icon: 'md-menu',
          title: '概况统计',
          // hideInMenu: true,
        },
        component: () => import('@/view/statistics/SummaryReport')
      },
      {
        path: '/data_browse/data_browse_realtime',
        name: 'data_browse_realtime',
        meta: {
          icon: 'md-menu',
          title: '实时数据',
          // hideInMenu: true,
        },
        component: () => import('@/view/statistics/point_live')
      },
      {
        path:'/data_browse/data_browse_dynaimic',
        name: 'data_browse_dynaimic', // 调整为directory_search
        meta: {
          icon: 'md-menu',
          title: '动态屏幕'
        },
        component: () => import('@/view/statistics/Movescreen')
      },
      {
        path: '/engineering/3D_diagram/:id',
        name: '3D_diagram',
        meta: {
          icon: 'md-menu',
          title: '初始值' // 后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/3D_diagram')
      },
      {
        path:'/engineering/2D_figure',
        name: '2D_figure',
        meta: { 
          icon: 'md-menu',
          title: '2D图',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/2D_figure')
      },
      {
        path:'/engineering/allData',
        name: 'allData',
        meta: { 
          icon: 'md-menu',
          title: '全部数据',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/allData')
      },
      {
        path:'/engineering/sensor_Figure',
        name: 'sensor_Figure',
        meta: { 
          icon: 'md-menu',
          title: '传感器图',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/sensor_Figure')
      },
      {
        path:'/engineering/relative_Displacement',
        name: 'relative_Displacement',
        meta: { 
          icon: 'md-menu',
          title: '相对位移',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/relative_Displacement')
      },
      {
        path:'/engineering/management',
        name: 'management',
        meta: { 
          icon: 'md-menu',
          title: '管理',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/management')
      },
      {
        path:'/engineering/3D_Stereogram',
        name: '3D_Stereogram',
        meta: { 
          icon: 'md-menu',
          title: '3D立体图',//后面的显示
        },
        hideInMenu: true,
        component: () => import('@/view/engineering/3D_Stereogram')
      },
    ]
  },
  {
    path: '/device_management',
    name: 'device_management',
    meta: {
      icon: 'md-settings',
      showAlways: true,
      title: '设备管理'
    },
    component: Main,
    children: [
      {
        path: '/device_management/index_station',
        name: 'index_station',
        meta: {
          icon: 'logo-playstation',
          title: '基站索引'
        },
        component: () => import('@/view/device_management/index_station')
      },
      {
        path: '/device_management/station_properties/:id',
        name: 'station_properties',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '基站属性'
        },
        component: () => import('@/view/device_management/station_properties')
      },
      {
        path: '/device_management/ditu/:id',
        name: 'ditu',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '地图标注'
        },
        component: () => import('@/view/device_management/ditu')
      },
      {
        path: '/device_management/index_node',
        name: 'index_node',
        meta: {
          icon: 'ios-stats',
          title: '节点索引'
        },
        component: () => import('@/view/device_management/index_node')
      },
      {
        path: '/device_management/node_properties/:id',
        name: 'node_properties',
        meta: {
          hideInMenu: true,
          icon: 'ios-stats',
          title: '节点属性'
        },
        component: () => import('@/view/device_management/node_properties')
      },
      {
        path: '/device_management/index_channel',
        name: 'index_channel',
        meta: {
          icon: 'md-git-compare',
          title: '通道索引'
        },
        component: () => import('@/view/device_management/index_channel')
      },
      {
        path: '/device_management/bulk_import',
        name: 'bulk_import',
        meta: {
          icon: 'md-list-box',
          title: '批量导入'
        },
        component: () => import('@/view/device_management/bulk_import')
      },
      {
        path: '/device_management/bulk_gongshi',
        name: 'bulk_gongshi',
        meta: {
          icon: 'md-list-box',
          title: '批量导入公式'
        },
        component: () => import('@/view/device_management/bulk_gongshi')
      },
      {
        path: '/device_management/channel_properties/:id',
        name: 'channel_properties',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '通道属性'
        },
        component: () => import('@/view/device_management/channel_properties')
      },
      {
        path: '/device_management/channel_data/:id',
        name: 'channel_data',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '通道数据'
        },
        component: () => import('@/view/device_management/channel_data')
      },
      {
        path: '/device_management/index_sensor',
        name: 'index_sensor',
        meta: {
          icon: 'md-analytics',
          title: '传感器索引'
        },
        component: () => import('@/view/device_management/index_sensor')
      },
      {
        path: '/device_management/sensor_property/:id',
        name: 'sensor_property',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '传感器属性'
        },
        component: () => import('@/view/device_management/sensor_property')
      },
      {
        path: '/device_management/sensor_data/:id',
        name: 'sensor_data',
        meta: {
          hideInMenu: true,
          icon: 'md-list-box',
          title: '传感器数据'
        },
        component: () => import('@/view/device_management/sensor_data')
      },
      
    ]
  },
  {
    path: '/device_control',
    name: 'device_control',
    meta: {
      icon: 'md-construct',
      showAlways: true,
      title: '设备控制'
    },
    component: Main,
    children: [
      {
        path: '/device_control/device_instruction',
        name: 'device_instruction',
        meta: {
          icon: 'md-swap',
          title: '设备指令'
        },
        component: () => import('@/view/device_control/device_instruction')
      },
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
